import { Flex, Text } from "@chakra-ui/react"

type Props = {
  firstName: string
  lastName: string
}

const UserAvatar = ({ firstName, lastName }: Props) => {
  return (
    <Flex
      align="center"
      justify="center"
      border="1px solid"
      borderColor="gray.350"
      borderRadius="full"
      bgColor="gray.200"
      w="8"
      h="8"
      className="avatar"
    >
      <Text as="span" fontSize="xs" fontWeight="normal">{`${firstName[0] ?? ""}${lastName[0] ?? ""}`}</Text>
    </Flex>
  )
}

export default UserAvatar
